import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import { environment } from '@env';
import { loadLazyStyles } from '@qtek/libs/app-component';
import 'hammerjs';
import { AppModule } from './app/app.module';
import './locales';

import { platformBrowser } from '@angular/platform-browser';
import { datadogRum } from '@datadog/browser-rum';

if (environment.dataDogRumEnabled) {
  datadogRum.init({
    applicationId: environment.dataDogRumApiId,
    clientToken: environment.dataDogRumClientToken,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: environment.dataDogRumService,
    env: environment.dataDogRumEnv,
    sessionSampleRate: environment.dataDogRumSessionSampleRate,
    sessionReplaySampleRate: environment.dataDogRumSessionReplaySampleRate,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

loadLazyStyles(environment.appName);

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, {
  applicationProviders: [provideZoneChangeDetection()],
});
// .catch(err => console.log(err));
